import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from '@phosphor-icons/react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STORAGE_KEY = 'solefinder_recently_viewed';
const MAX_RECENT = 12;

export function addToRecentlyViewed(shoeId) {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const filtered = stored.filter(id => id !== shoeId);
    filtered.unshift(shoeId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_RECENT)));
  } catch { /* localStorage not available */ }
}

export function getRecentlyViewedIds() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch { return []; }
}

export default function RecentlyViewed({ excludeId = null, maxShow = 6 }) {
  const [shoes, setShoes] = useState([]);

  useEffect(() => {
    const ids = getRecentlyViewedIds().filter(id => id !== excludeId).slice(0, maxShow);
    if (ids.length === 0) return;
    axios.post(`${API}/shoes/batch`, { shoe_ids: ids })
      .then(({ data }) => {
        const ordered = ids.map(id => data.find(s => s.shoe_id === id)).filter(Boolean);
        setShoes(ordered);
      })
      .catch(() => {});
  }, [excludeId, maxShow]);

  if (shoes.length === 0) return null;

  return (
    <section className="py-10" data-testid="recently-viewed">
      <div className="flex items-center gap-2 mb-6">
        <Clock size={22} weight="duotone" className="text-[#52525B]" />
        <h3 className="font-heading font-bold text-xl tracking-tight uppercase">Recently Viewed</h3>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-4 -mx-2 px-2 snap-x snap-mandatory scrollbar-thin" data-testid="recently-viewed-carousel">
        {shoes.map((shoe, i) => (
          <motion.div key={shoe.shoe_id} className="snap-start flex-shrink-0 w-48" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}>
            <Link to={`/shoe/${shoe.shoe_id}`} className="block border border-[#E4E4E7] bg-white hover:border-[#0A0A0A] transition-all group" data-testid={`recent-${shoe.shoe_id}`}>
              <div className="overflow-hidden">
                <img src={shoe.image_url} alt={`${shoe.brand} ${shoe.model}`} className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
              <div className="p-3">
                <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#52525B]">{shoe.brand}</p>
                <p className="font-heading font-bold text-xs mt-0.5 truncate">{shoe.model}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
